(function() {
  'use strict';

  /* 1. HEADER — Force glass pill */
  function forceGlassHeader() {
    var component = document.querySelector('header-component');
    if (!component) return;

    function applyGlass() {
      var headerRow = document.querySelector('.header__row--top');
      if (headerRow) {
        headerRow.style.setProperty('opacity', '1', 'important');
        headerRow.style.setProperty('visibility', 'visible', 'important');
        headerRow.style.setProperty('transform', 'none', 'important');
        headerRow.style.setProperty('background', 'transparent', 'important');
      }

      component.style.setProperty('position', 'fixed', 'important');
      component.style.setProperty('top', '30px', 'important');
      component.style.setProperty('left', '14px', 'important');
      component.style.setProperty('right', '14px', 'important');
      component.style.setProperty('width', 'auto', 'important');
      component.style.setProperty('z-index', '9999', 'important');
      component.style.setProperty('background', 'rgba(255,255,255,0.09)', 'important');
      component.style.setProperty('backdrop-filter', 'blur(6px)', 'important');
      component.style.setProperty('-webkit-backdrop-filter', 'blur(6px)', 'important');
      component.style.setProperty('border-radius', '20px', 'important');
      component.style.setProperty('border', '1px solid rgba(255,255,255,0.08)', 'important');
      component.style.setProperty('overflow', 'hidden', 'important');

      component.querySelectorAll('[class*="color-scheme"]').forEach(function(el) {
        el.style.setProperty('background', 'transparent', 'important');
        el.style.setProperty('background-color', 'transparent', 'important');
      });

      document.querySelectorAll('.header__underlay').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
      });

      var navRow = document.querySelector('.header__navigation-bar-row');
      if (navRow) navRow.style.setProperty('display', 'none', 'important');
    }

    applyGlass();

    // Re-apply when Tinker mutates the header. Disconnect before applying to avoid
    // triggering the observer on our own style writes, reconnect after settling.
    var observer = new MutationObserver(function() {
      observer.disconnect();
      requestAnimationFrame(function() {
        applyGlass();
        requestAnimationFrame(function() {
          observer.observe(component, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
        });
      });
    });
    observer.observe(component, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
  }

  /* 2. PRODUCT CARD HOVER — Image crossfade */
  function initProductCardHover() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    cards.forEach(function(card) {
      var img = card.querySelector('.card__media img, .media img');
      var hoverSrc = card.getAttribute('data-hover-image');
      if (!img || !hoverSrc) return;

      var originalSrc = img.src;
      card.addEventListener('mouseenter', function() {
        img.style.transition = 'opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1)';
        img.style.opacity = '0';
        setTimeout(function() { img.src = hoverSrc; img.style.opacity = '1'; }, 250);
      });
      card.addEventListener('mouseleave', function() {
        img.style.opacity = '0';
        setTimeout(function() { img.src = originalSrc; img.style.opacity = '1'; }, 250);
      });
    });
  }

  /* 3. SCROLLING MARQUEE — Scroll-reactive */
  function initMarquee() {
    var mq1 = document.getElementById('mq1');
    var mq2 = document.getElementById('mq2');
    var mq3 = document.getElementById('mq3');
    if (!mq1) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var y = window.pageYOffset;
          if (mq1) mq1.style.transform = 'translate3d(' + (-y * 0.15) + 'px, 0, 0)';
          if (mq2) mq2.style.transform = 'translate3d(' + (y * 0.1) + 'px, 0, 0)';
          if (mq3) mq3.style.transform = 'translate3d(' + (-y * 0.07) + 'px, 0, 0)';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* 4. SCROLL REVEAL */
  function initScrollReveal() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    function observeAll() {
      document.querySelectorAll('.reveal-on-scroll:not(.revealed)').forEach(function(el) {
        observer.observe(el);
      });
    }

    // Auto-tag product list section heading (dynamic block, can't add class in Liquid)
    document.querySelectorAll('.ui-test-product-list h2, .ui-test-product-list h3').forEach(function(el) {
      el.classList.add('reveal-on-scroll');
    });

    // Auto-tag homepage product cards that don't already have the class
    document.querySelectorAll('.product-grid__item:not(.reveal-on-scroll)').forEach(function(el) {
      el.classList.add('reveal-on-scroll');
    });

    observeAll();

    // Re-observe when AJAX filter/sort replaces the product grid
    var mutationObserver = new MutationObserver(function() {
      observeAll();
    });

    var grid = document.querySelector('results-list, .product-grid, .collection-wrapper');
    if (grid) {
      mutationObserver.observe(grid, { childList: true, subtree: true });
    }
  }

  /* 5. AUTO-APPLY glass-card to product cards */
  function initProductCards() {
    document.querySelectorAll('.card-wrapper .card, .product-card-wrapper .card, .grid__item .card').forEach(function(card) {
      if (!card.classList.contains('glass-card')) card.classList.add('glass-card');
    });
  }

  /* 6. FLOATING NAV — sliding glass pill indicator */
  function initFloatNav() {
    var nav = document.getElementById('float-nav');
    var slider = document.getElementById('float-nav-slider');
    if (!nav || !slider) return;

    // Force fixed positioning via inline styles
    nav.style.setProperty('position', 'fixed', 'important');
    nav.style.setProperty('top', 'calc(30px + var(--header-height, 60px) / 2)', 'important');
    nav.style.setProperty('bottom', 'auto', 'important');
    nav.style.setProperty('left', '50%', 'important');
    nav.style.setProperty('transform', 'translateX(-50%) translateY(-50%)', 'important');
    nav.style.setProperty('z-index', '10000', 'important');

    var items = nav.querySelectorAll('.float-nav__item');
    var activeItem = nav.querySelector('.float-nav__item--active') || items[0];

    function moveSlider(el) {
      var navRect = nav.getBoundingClientRect();
      var elRect = el.getBoundingClientRect();
      slider.style.left = (elRect.left - navRect.left) + 'px';
      slider.style.width = elRect.width + 'px';
    }

    // Set initial position without transition
    slider.style.transition = 'none';
    moveSlider(activeItem);
    requestAnimationFrame(function() {
      slider.style.transition = '';
    });

    items.forEach(function(item) {
      item.addEventListener('mouseenter', function() { moveSlider(item); });
    });

    nav.addEventListener('mouseleave', function() { moveSlider(activeItem); });
  }

  /* 7. ACCOUNT DIALOG — inject dark glass styles into Shadow DOM */
  function initAccountDialogStyles() {
    var STYLE_ID = 'glass-account-styles';

    var css = [
      'dialog {',
      '  background: rgba(20,20,20,0.95) !important;',
      '  backdrop-filter: blur(15px) !important;',
      '  -webkit-backdrop-filter: blur(15px) !important;',
      '  border: 1px solid rgba(255,255,255,0.1) !important;',
      '  border-radius: 16px !important;',
      '  box-shadow: 0 24px 80px rgba(0,0,0,0.5) !important;',
      '  color: rgba(255,255,255,0.85) !important;',
      '}',
      'dialog::backdrop { background: rgba(0,0,0,0.6) !important; }',
      '* { color: rgba(255,255,255,0.85); }',
      'h1, h2, h3, h4, strong { color: #ffffff !important; }',
      'hr {',
      '  border-color: rgba(255,255,255,0.15) !important;',
      '  opacity: 1 !important;',
      '}',
      '[class*="divider"], [class*="separator"], [role="separator"] {',
      '  border-color: rgba(255,255,255,0.15) !important;',
      '  color: rgba(255,255,255,0.4) !important;',
      '}',
      'input[type=email], input[type=text], input[type=tel], input {',
      '  background: rgba(255,255,255,0.05) !important;',
      '  background-color: rgba(255,255,255,0.05) !important;',
      '  color: #ffffff !important;',
      '  border-color: rgba(255,255,255,0.15) !important;',
      '  caret-color: #ffffff !important;',
      '}',
      'input::placeholder { color: rgba(255,255,255,0.35) !important; }',
      '[class*="google"], [aria-label*="Google"], [aria-label*="google"],',
      '[data-provider="google"] {',
      '  background: rgba(255,255,255,0.1) !important;',
      '  color: #ffffff !important;',
      '  border: 1px solid rgba(255,255,255,0.15) !important;',
      '}',
      '[aria-label*="Close"], [aria-label*="close"],',
      '[aria-label*="Back"], [aria-label*="back"],',
      '[data-action="close"], [data-action="back"] {',
      '  background: transparent !important;',
      '  background-color: transparent !important;',
      '  color: #ffffff !important;',
      '  border: none !important;',
      '  box-shadow: none !important;',
      '}',
      'nav a, [role=navigation] a, [class*="account-link"], [class*="menu-link"] {',
      '  background: rgba(255,255,255,0.08) !important;',
      '  border: 1px solid rgba(255,255,255,0.15) !important;',
      '  color: #ffffff !important;',
      '  border-radius: 12px !important;',
      '}',
      'nav a:hover, [role=navigation] a:hover {',
      '  background: rgba(255,255,255,0.15) !important;',
      '}',
      'svg { color: inherit !important; }',
    ].join('\n');

    function injectStyles() {
      var el = document.querySelector('shopify-account');
      if (!el || !el.shadowRoot) return;
      if (el.shadowRoot.querySelector('#' + STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = css;
      el.shadowRoot.appendChild(style);
    }

    if (typeof customElements === 'undefined' || !customElements.whenDefined) return;

    customElements.whenDefined('shopify-account').then(function() {
      injectStyles();
      var el = document.querySelector('shopify-account');
      if (el && el.shadowRoot) {
        new MutationObserver(injectStyles).observe(el.shadowRoot, { childList: true });
      }
    });
  }

  /* 7. CART ICON BOUNCE — animate on count change */
  function initCartBounce() {
    var cartIcon = document.querySelector('cart-icon');
    if (!cartIcon) return;

    var bubble = cartIcon.querySelector('[class*="bubble"], [class*="count"], .cart-count-bubble, .cart-icon__bubble');
    if (!bubble) {
      // fallback: observe the whole cart-icon subtree for any text/child change
      bubble = cartIcon;
    }

    var bouncing = false;
    function bounce() {
      if (bouncing) return;
      bouncing = true;
      cartIcon.classList.add('cart--bounce');
      cartIcon.addEventListener('animationend', function handler() {
        cartIcon.classList.remove('cart--bounce');
        bouncing = false;
        cartIcon.removeEventListener('animationend', handler);
      });
    }

    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var val = m.target.textContent || '';
        if (val.trim() !== '' && val.trim() !== '0') { bounce(); break; }
      }
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* Product gallery mobile swipe — reinforces native scroll-snap with touch events */
  function initGallerySwipe() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var slides = gallery.querySelector('slideshow-slides');
    if (!slides) return;

    var startX = 0;
    var threshold = 40;

    slides.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slides.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < threshold) return;

      var slideEls = gallery.querySelectorAll('slideshow-slide');
      var current = -1;
      slideEls.forEach(function(s, i) {
        if (s.getAttribute('aria-hidden') === 'false') current = i;
      });
      if (current === -1) return;

      var target = dx < 0
        ? Math.min(current + 1, slideEls.length - 1)
        : Math.max(current - 1, 0);

      if (target === current) return;

      var thumbs = gallery.querySelectorAll('.slideshow-controls__thumbnail');
      if (thumbs[target]) thumbs[target].click();
    }, { passive: true });
  }

  /* 9. QUICK VIEW MODAL */
  function initQuickView() {
    var overlay = null;
    var modal = null;
    var currentVariantId = null;
    var allVariants = [];

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return '\u20b9' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function buildModal() {
      overlay = document.createElement('div');
      overlay.className = 'qv-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.innerHTML =
        '<div class="qv-modal">' +
          '<button class="qv-modal__close" aria-label="Close quick view">&times;</button>' +
          '<div class="qv-modal__img-wrap">' +
            '<img class="qv-modal__img" src="" alt="" loading="lazy">' +
          '</div>' +
          '<div class="qv-modal__info">' +
            '<p class="qv-modal__vendor"></p>' +
            '<h2 class="qv-modal__title"></h2>' +
            '<div class="qv-modal__price-wrap">' +
              '<span class="qv-modal__price"></span>' +
              '<span class="qv-modal__compare-price"></span>' +
            '</div>' +
            '<div class="qv-modal__variant-section" style="display:none">' +
              '<p class="qv-modal__variant-label">Options</p>' +
              '<div class="qv-modal__variants"></div>' +
            '</div>' +
            '<button class="qv-modal__atc">Add to Cart</button>' +
            '<a class="qv-modal__link" href="#">View Full Details</a>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);

      modal = overlay.querySelector('.qv-modal');

      overlay.querySelector('.qv-modal__close').addEventListener('click', closeModal);
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeModal();
      });

      overlay.querySelector('.qv-modal__atc').addEventListener('click', function() {
        if (!currentVariantId) return;
        var btn = this;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: currentVariantId, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.textContent = 'Added!';
          setTimeout(function() { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var cartEl = document.querySelector('cart-icon, cart-count-bubble');
          if (cartEl) cartEl.dispatchEvent(new CustomEvent('refresh'));
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        });
      });
    }

    function openModal() {
      overlay.style.display = 'flex';
      requestAnimationFrame(function() {
        overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.addEventListener('transitionend', function handler() {
        overlay.style.display = 'none';
        overlay.removeEventListener('transitionend', handler);
      });
      document.body.style.overflow = '';
    }

    function selectVariant(variantId) {
      currentVariantId = variantId;
      var v = allVariants.find(function(x) { return x.id === variantId; });
      if (!v) return;

      overlay.querySelector('.qv-modal__price').textContent = formatMoney(v.price);

      var compareEl = overlay.querySelector('.qv-modal__compare-price');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }

      if (v.featured_image && v.featured_image.src) {
        overlay.querySelector('.qv-modal__img').src = v.featured_image.src.replace(/\.jpg|\.png|\.webp/, '_800x800$&');
      }

      var atcBtn = overlay.querySelector('.qv-modal__atc');
      if (v.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }

      overlay.querySelectorAll('.qv-modal__variant-btn').forEach(function(btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.variantId) === variantId);
      });
    }

    function populate(product) {
      allVariants = product.variants;
      var defaultVariant = product.variants[0];
      currentVariantId = defaultVariant.id;

      var img = product.featured_image
        ? product.featured_image.replace(/\.jpg|\.png|\.webp/, '_800x800$&')
        : '';
      overlay.querySelector('.qv-modal__img').src = img;
      overlay.querySelector('.qv-modal__img').alt = product.title;

      var vendorEl = overlay.querySelector('.qv-modal__vendor');
      if (product.vendor) {
        vendorEl.textContent = product.vendor;
        vendorEl.style.display = '';
      } else {
        vendorEl.style.display = 'none';
      }

      overlay.querySelector('.qv-modal__title').textContent = product.title;

      overlay.querySelector('.qv-modal__link').href = '/products/' + product.handle;
      overlay.querySelector('.qv-modal__link').textContent = 'View Full Details \u2192';

      var variantSection = overlay.querySelector('.qv-modal__variant-section');
      var variantsEl = overlay.querySelector('.qv-modal__variants');
      variantsEl.innerHTML = '';

      var hasOptions = product.variants.length > 1 ||
        (product.options && product.options.length === 1 && product.options[0] !== 'Title');

      if (hasOptions) {
        variantSection.style.display = '';
        if (product.options && product.options.length === 1) {
          overlay.querySelector('.qv-modal__variant-label').textContent = product.options[0];
        }
        product.variants.forEach(function(v) {
          var btn = document.createElement('button');
          btn.className = 'qv-modal__variant-btn' + (v.available ? '' : ' is-unavailable');
          btn.textContent = v.title === 'Default Title' ? 'Default' : v.title;
          btn.dataset.variantId = v.id;
          btn.addEventListener('click', function() {
            if (!v.available) return;
            selectVariant(v.id);
          });
          variantsEl.appendChild(btn);
        });
      } else {
        variantSection.style.display = 'none';
      }

      selectVariant(currentVariantId);
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.qv-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.dataset.handle;
      if (!handle) return;

      if (!overlay) buildModal();
      overlay.style.display = 'flex';
      overlay.querySelector('.qv-modal__title').textContent = 'Loading…';
      overlay.querySelector('.qv-modal__img').src = '';
      overlay.querySelector('.qv-modal__price').textContent = '';
      overlay.querySelector('.qv-modal__compare-price').textContent = '';
      overlay.querySelector('.qv-modal__variants').innerHTML = '';
      overlay.querySelector('.qv-modal__variant-section').style.display = 'none';
      requestAnimationFrame(function() { overlay.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) { populate(product); })
        .catch(function() {
          overlay.querySelector('.qv-modal__title').textContent = 'Could not load product.';
        });
    });
  }

  /* INIT */
  function init() {
    forceGlassHeader();
    initAccountDialogStyles();
    initProductCards();
    initProductCardHover();
    initMarquee();
    initScrollReveal();
    initFloatNav();
    initCartBounce();
    initGallerySwipe();
    initQuickView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
